export const moonshotai_cnModels = {
    id: "moonshotai-cn",
    name: "Moonshot AI (China)",
    api: "https://api.moonshot.cn/v1",
    npm: "@ai-sdk/openai-compatible",
    doc: "https://platform.moonshot.cn/docs/api/chat",
    env: ["MOONSHOT_API_KEY"],
    models: {
        "kimi-k2-0905-preview": {
            id: "kimi-k2-0905-preview",
            name: "Kimi K2 0905",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2025-09-05",
            last_updated: "2025-09-05",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.6,
                output: 2.5,
                cache_read: 0.15,
            },
            limit: {
                context: 262144,
                output: 262144,
            },
        },
        "kimi-k2-0711-preview": {
            id: "kimi-k2-0711-preview",
            name: "Kimi K2 0711",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2025-07-14",
            last_updated: "2025-07-14",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.6,
                output: 2.5,
                cache_read: 0.15,
            },
            limit: {
                context: 131072,
                output: 16384,
            },
        },
        "kimi-k2-turbo-preview": {
            id: "kimi-k2-turbo-preview",
            name: "Kimi K2 Turbo",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2025-09-05",
            last_updated: "2025-09-05",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 2.4,
                output: 10,
                cache_read: 0.6,
            },
            limit: {
                context: 262144,
                output: 262144,
            },
        },
    },
};
export default moonshotai_cnModels;
//# sourceMappingURL=moonshotai-cn.js.map